import AppDownload from "@/components/landing/homeTwo/AppDownload";
import Banner from "@/components/landing/homeTwo/Banner";
import CallAction from "@/components/landing/homeTwo/CallAction";
import Features from "@/components/landing/homeTwo/Features";
import HappyUsers from "@/components/landing/homeTwo/HappyUsers";
import HowItsWork from "@/components/landing/homeTwo/HowItsWork";
import Security from "@/components/landing/homeTwo/Security";
import Testimonials from "@/components/landing/homeTwo/Testimonials";
import WhyChoose from "@/components/landing/homeTwo/WhyChoose";

export default function HomeTwo() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* How Its Work section */}
      <HowItsWork />

      {/* Why Choose section */}
      <WhyChoose />

      {/* App Download section */}
      <AppDownload />

      {/* Features section */}
      <Features />

      {/* Call Action section */}
      <CallAction />

      {/* Testimonials section */}
      <Testimonials />

      {/* Happy Users section */}
      <HappyUsers />

      {/* Security section */}
      <Security />
    </>
  );
}
